import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Typography from "material-ui/Typography";
import { keywordsMaxSize } from '../../../constants/LetterAIValues';
import TextField from 'material-ui/TextField';
import Button from 'material-ui/Button';

const styles = () => ({
  root: {
    position: "relative",
    width: "100%",
  },

  title: {
    fontSize: "13px",
    fontWeight: "bold",
    width: "100%",
    "&::after": {
      position: "relative",
      marginTop: "10px",
      width: "100%",
      borderBottom: "1px solid #D9DBDF",
      content: '""',
      display: "block",
      height: "1px",
      top: "0",
    }
  },

  desc: {
    fontSize: "11px",
    marginTop: "20px",
  },

  keywords: {
    marginTop: "20px",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
  },

  keyword: {
    width: "350px",
  },

  addKeywordButton: {
    width: "350px",
    height: "40px",
    borderRadius: "2px",
    fontSize: "13px",
    border: "1px dashed #A2A2A2",
    display: "flex",
    justifyContent: "left",
    color: "#A2A2A2",
    transition: "0.4s",
    "&:hover": {
      border: "1px solid #E3E6E8",
      background: "#E3E6E8",
      width: "340px",
      marginRight: "10px",
    },
  },
});

class KeywordsControl extends React.Component {
  render() {
    const { classes, keywords, disabled } = this.props;

    const firstKeyword = 1
    const secondKeyword = 2
    return (
      <div className={classes.root} style={this.props.style}>
        <Typography
          variant="body2"
          className={classes.title}
        >
          キーワードを入力
        </Typography>
        <Typography
          variant="body2"
          className={classes.desc}
        >
          レター文面に入れたいキーワードを入力してください(会社名・サービス名称・サービスの特徴等)
        </Typography>
        <div className={classes.keywords}>
          {keywords.entrySeq().map(([index, value]) => (
            <TextField
              className={classes.keyword}
              style={{ marginBottom: (index !== keywords.size - firstKeyword || index === (keywordsMaxSize - secondKeyword) || index === (keywordsMaxSize - firstKeyword)) ? "10px" : "0px" }}
              id={index}
              key={index}
              type={"text"}
              placeholder={"キーワードを入力"}
              value={value}
              onChange={(e) => this.props.handleChange(e, "keywords", index)}
              InputProps={{
                disableUnderline: true,
              }}
              disabled={disabled}
            />
          ))}
          {keywords.size < keywordsMaxSize && (
            <Button className={classes.addKeywordButton} disabled={disabled} onClick={() => this.props.handleAddMapItem("keywords")}>
              + キーワードを追加
            </Button>
          )}
        </div>
      </div>
    )
  }
}

KeywordsControl.propTypes = {
  classes: PropTypes.object.isRequired,
  style: PropTypes.object,
  disabled: PropTypes.bool,
  keywords: PropTypes.object,
  handleChange: PropTypes.func.isRequired,
  handleAddMapItem: PropTypes.func.isRequired,
};

export default withStyles(styles)(KeywordsControl);



// WEBPACK FOOTER //
// ./src/components/LetterAutoGenerate/controls/KeywordsControl.jsx